// extracted by mini-css-extract-plugin
module.exports = {"contactLink":"about-module--contact-link--3_riV","content":"about-module--content--1y3Xq"};